<template>
    <div>
        <b-modal
            id="delete-modal"
            size="sm"
            header-bg-variant="dark"
            hide-footer
        >
            <template v-slot:modal-header>
                <h5 class="modal-title text-white">
                <b>Supprimer l'alerte</b>
                </h5>
                <i class="fa fa-times text-white" aria-hidden="true" @click="$bvModal.hide('delete-modal')"></i>
            </template> 
            <!-- {{item.patient.name}} -->
            <div class="d-block text-center" v-if="item.patient">
                <p><span class="font-weight-bold"> Nom: </span> {{item.patient.name}}</p>
                <span><span class="font-weight-bold">Statut: </span>{{item.statut.description}}</span>
                <p><span class="font-weight-bold">Plainte: </span> {{item.plainte}}</p>
                <p><span class="font-weight-bold">Date: </span> {{formattedDateTime(item.created_at)}}</p>
            </div>

            <div class="d-block float-right" v-if="item">
                <b-button variant="outline-danger" @click="deleteAlerte(item.id)"> <!-- @click="deleteAlerte"-->
                    {{ $t('message.delete') }}
                </b-button>
                <b-button variant="secondary" @click="$bvModal.hide('delete-modal')"><!--@click="$bvModal.hide('delete-modal')"-->
                    {{ $t('message.cancel') }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import moment from "moment";
import Swal from 'sweetalert2';
import Vue from 'vue';
import {mapGetters} from "vuex";
import Multiselect from 'vue-multiselect'
import AppConfig from "../../constants/AppConfig";
import axios from 'axios';

export default {
    name: "ModalDeleteAlerte",
    props: ['item'],

    computed: {
        ...mapGetters(["errors", 'hasPatientRole', 'hasAdminRole', 'hasGestionnaireRole','alertes','urgences']),
    },
    
    data() {
        return {
            placements: [
                'topright',
            ],
            oldData: this.alerte,
            liste_patient: [],
            loading: false,
            patientState: null,
            niveaUrgenceState: null,
            plainteState: null,
            submittedNames: [],
            alertForm: false,
            settings: false,
            singleAlert:{},
            Home: false,
            mobileView: true,
            uuid: this.$route.query.uuid,
            search: ""
        }
    },

    methods: {
        deleteAlerte(alerte) {
            let args = {
                alerte: alerte,
            };
            let successMessage = this.$i18n.t('message.alertDeleted');
            let errorMessages = {
                generic: this.$i18n.t('message.genericError'),
                error: this.$i18n.t('message.error')
            };
            this.$bvModal.hide('delete-modal');
            this.$store.dispatch('deleteAlerte', {args, successMessage, errorMessages})
            .then(() => {
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            });


               
        },
        formattedDateTime(date) {
            if (moment(date).isValid() && date != null) {
                return moment(date).format("DD-MM-YYYY à HH:mm");
            } else {
                return date;
            }
        },

    },
    mounted() {
        
    },
  
    
}
</script>